import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { AuthenticationEndpoint } from '@app/services/authentication/authentication-endpoints.service';

@Injectable()
export class AuthenticationService {

  constructor(private router: Router, private http: Http,
    private authenticationEndpoint: AuthenticationEndpoint) {
  }

  login(username: string, password: string) {
    return this.authenticationEndpoint.login(username, password)
      .map((response: Response) => response);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication/authentication.service.ts